import React from 'react'

import yamadumiAuth from '../../Auth'
import { useUnsafeOnceCall } from '../../components/hooks'
import { CommonActions, useAppDispatch } from '../../stores'
import { AuthenticateProgress } from './AuthenticateProgress'

export default function Logout() {
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const dispatch = useAppDispatch()
  const onceCall = useUnsafeOnceCall()

  React.useEffect(() => {
    // React.StrictModeでは、開発環境においてコンポーネントを２回マウントする。
    // 以下のログアウト処理も２度呼ばれてしまう。
    // APIの仕様上、２度呼んでも問題は無いが、
    // サーバへの余計な負荷をかけたくない意味で１度だけ呼ぶようにする。
    onceCall(() => {
      yamadumiAuth.logout()
        .then(() => {
          dispatch(CommonActions.logout())
        })
        .catch((error: Error) => {
          setError(true)
          setErrorMessage(error.message)
        })
    })
  })

  return <AuthenticateProgress
    message={error ? 'ログアウト処理中にエラーが発生しました' : 'ログアウト処理中です...'}
    subMessage={errorMessage}
    returnToBefore={error} />
}
